import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Camps2 from "./Camps2";
import Testimonials from "./Testimonials";
import reviews from "./data";



import camp1 from "../../Assets/cf_1.png";
import camp2 from "../../Assets/cf_2.png";






// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";
import { useTranslation } from "react-i18next";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: camp1, altKey: "programs.camps.slider.alt1" },
  { src: camp2, altKey: "programs.camps.slider.alt2" },





  // Add more images as needed

  ];


function Camps() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const navigate = useNavigate(); // Initialize navigate
  
  
  
  const handleClick = () => {
    navigate("/registration#techcamps-section"); // This will navigate to the "/another-page" route
  };



  // Settings for the Slick slider
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 700, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3600, // Time between slides in ms
    pauseOnHover: true,
    pauseOnFocus: true,
    lazyLoad: "progressive",
    beforeChange: (_current, next) => setActiveSlide(next),
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <SlickLazyImage
                    src={image.src}
                    alt={t(image.altKey)}
                    className="img-fluid program-page-slide-img"
                    index={index}
                    activeIndex={activeSlide}
                    total={sliderImages.length}
                    buffer={2}
                    eager
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>

     
      
      <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  {t("common.registerNow")}
</Button>

     

          <Camps2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default Camps;


